import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as modalReducer } from 'react-redux-modal';
import { reducer as formReducer } from 'redux-form';
import authReducer from './auth';
import dataReducer from './data';
import navReducer from './nav';
import camGroupReducer from './camgroup';
import channelsReducer from './channels';
import currentItemReducer from './currentItem';
import blogReducer from './blogposts';
import relatedSnapshotsReducer from './relatedSnapshots';
import snapshotsReducer from './snapshots';
import globalReducer from './globalConfig';
import favoritesReducer from './favorites';
import errorsReducer from './errors';
import alertsReducer from './alerts';
import currentUser from './currentUser';
import memberProfile from './memberProfile';
import metadata from './metadata';
import takeSnapshot from './takeSnapshot';
import uiPreferences from './uiPreferences';
import gfyReducer from './gfy';
import calendarEvents from './calendarEvents';

export default combineReducers({
  auth: authReducer,
  data: dataReducer,
  nav: navReducer,
  blogPosts: blogReducer,
  relatedSnapshots: relatedSnapshotsReducer,
  snapshots: snapshotsReducer,
  channels: channelsReducer,
  cam_groups: camGroupReducer,
  currentItem: currentItemReducer,
  gfy: gfyReducer,
  modals: modalReducer,
  form: formReducer,
  routing: routerReducer,
  globalConfig: globalReducer,
  favorites: favoritesReducer,
  errors: errorsReducer,
  alerts: alertsReducer,
  currentUser,
  memberProfile,
  metadata,
  takeSnapshot,
  uiPreferences,
  calendarEvents,
});
